import Efficiency from './efficiency.component';

export default Efficiency;
